<script>
import {ref} from "vue";
import {useRouter} from "vue-router";
import {useConfig} from "@/helpers/config-effect";
import {useStore} from "@/helpers/store-effect";
import useNotifications from "@/helpers/notify-effect";
import {Workflow} from "@/models/workflow";

export default {
  name: 'WorkflowImport',
  template: '#workflow-import-template',
  setup() {
    const workflow = ref('');
    const dragAndDrop = ref(false);
    const router = useRouter();
    const config = useConfig();
    const store = useStore();
    const {notify} = useNotifications();

    const close = () => {
      router.push({path: '../'});
    };

    const process = () => {
      let importedWorkflow = new Workflow({...config.workflow.defaults, ...(JSON.parse(workflow.value) || {})});
      importedWorkflow = importedWorkflow.duplicate();
      importedWorkflow.name += ' (Imported)';

      store.workflow = importedWorkflow;

      notify('Import', 'The workflow has been imported.', 'success')

      router.push({
        name: 'editor',
        params: {
          uid: importedWorkflow.uid,
        },
      });
    };

    const dragEnter = () => {
      dragAndDrop.value = true;
    };

    const dragLeave = () => {
      dragAndDrop.value = false;
    };

    const drop = (event) => {
      dragAndDrop.value = false;
      const file = event.dataTransfer.files[0];

      if (file.type !== 'application/json') {
        alert('Not a valid JSON file');
      }

      file.text().then(content => workflow.value = content);
    };

    return {
      close,
      process,
      workflow,
      dragEnter,
      dragLeave,
      drop,
      dragAndDrop
    };
  }
}
</script>
